export default __webpack_public_path__ + "static/media/pattern.0b839396.png";